numeral.register('locale', 'ja', {
    delimiters: {
        thousands: ',',
        decimal: '.',
    },
    abbreviations: {
        thousand: '千',
        million: '百万',
        billion: '十億',
        trillion: '兆',
    },
    ordinal: () => '.',
    currency: {
        symbol: '¥',
    },
});
